<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
</script>

<template>
  <div class="mobile-gate">
    <section class="intro">
      <img class="logo" src="@/assets/logo.svg" alt="" />

      <div class="hero">
        <h1 class="headline">{{ $t("onboarding.mobileGate.headline") }}</h1>
        <p class="subhead">{{ $t("onboarding.mobileGate.subhead") }}</p>
      </div>

      <ul class="reasons">
        <li class="reason">
          <span class="reason-iconwrap">
            <SvgIcon class="reason-icon" name="board/planning" />
          </span>
          <span class="reason-text">{{ $t("onboarding.mobileGate.reasons.boards") }}</span>
        </li>
        <li class="reason">
          <span class="reason-iconwrap">
            <SvgIcon class="reason-icon" name="general/sticky" />
          </span>
          <span class="reason-text">{{ $t("onboarding.mobileGate.reasons.stickies") }}</span>
        </li>
        <li class="reason">
          <span class="reason-iconwrap">
            <SvgIcon class="reason-icon" name="general/link" />
          </span>
          <span class="reason-text">{{ $t("onboarding.mobileGate.reasons.dependencies") }}</span>
        </li>
      </ul>
    </section>

    <section class="next-step">
      <p class="action-title">{{ $t("onboarding.mobileGate.actionTitle") }}</p>
      <p class="action-detail">{{ $t("onboarding.mobileGate.actionDetail") }}</p>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.mobile-gate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 56px;
  min-height: 100dvh;
  padding: 64px 24px;
  background-color: colors.$background-ui;
  text-align: center;
}

.intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  width: 100%;
  max-width: 420px;
}

.logo {
  height: 28px;
}

.hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.headline {
  @include typography.heading;

  margin: 0;
  color: colors.$text;
  line-height: 1.2;
}

.subhead {
  @include typography.large("medium");

  margin: 0;
  color: colors.$text-subtle;
  line-height: 1.5;
}

.reasons {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  margin: 0;
  padding: 24px 20px;
  list-style: none;
  background-color: colors.$background-grey-light;
  border-radius: 16px;
}

.reason {
  display: flex;
  align-items: center;
  gap: 14px;
  text-align: left;
}

.reason-iconwrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  background-color: colors.$background-ui;
  border-radius: 10px;
}

.reason-icon {
  width: 20px;
  height: 20px;
  color: colors.$main;
}

.reason-text {
  @include typography.medium("medium");

  color: colors.$text;
  line-height: 1.4;
}

.next-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 420px;
}

.action-title {
  @include typography.extra-large;

  margin: 0;
  color: colors.$main;
  line-height: 1.3;
}

.action-detail {
  @include typography.medium("regular");

  margin: 4px 0 0;
  color: colors.$text-subtle;
  line-height: 1.5;
}
</style>
